import React from 'react';
import { EllipsisLoader, palettes } from '@indigo-ag/component-module';

export const LoadingIndicator: React.FunctionComponent = () => (
  <EllipsisLoader
    style={{
      alignItems: 'center',
      color: palettes.legacy.blue.default,
      display: 'flex',
      flex: 1,
      fontSize: '2rem',
      justifyContent: 'center',
      margin: '2rem'
    }}
  />
);
